import { __decorate, __metadata } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ConfigOauthService, ApiService, UiBsOauthModule } from '@wlp/ui-bs-oauth';

let ConfigService = class ConfigService extends ConfigOauthService {
};
ConfigService = __decorate([
    Injectable()
], ConfigService);

const SPE_J_SPLIT = '/spe-j-split';
let SpeJSplitProxy = class SpeJSplitProxy {
    constructor(api) {
        this.api = api;
    }
    approveSplitItem(aproveSplitPayment) {
        const uri = `${SPE_J_SPLIT}/api/process/approve`;
        return this.api.post(uri, aproveSplitPayment);
    }
    cancelSplitItem(cancelSplitPayment) {
        const uri = `${SPE_J_SPLIT}/api/process/cancel`;
        return this.api.put(uri, cancelSplitPayment);
    }
    reprocessSplitItem(reprocessSplitPayment) {
        const uri = `${SPE_J_SPLIT}/api/process/reprocess`;
        return this.api.put(uri, reprocessSplitPayment);
    }
};
SpeJSplitProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeJSplitProxy);

const SPE_VIEW_N_SPLIT = '/spe-view-n-split';
let SpeViewNSplitProxy = class SpeViewNSplitProxy {
    constructor(api) {
        this.api = api;
    }
    getSplitLotsPaginatedWithFilter(uuid, uuidAccountPayment, dateStart, dateEnd, status, keyword, typeCode, paginationParams) {
        const body = {
            filter: {
                uuid: uuid ? uuid : null,
                uuidAccountPayment: uuidAccountPayment ? uuidAccountPayment : null,
                status: status ? status : null,
                dateStart: dateStart ? dateStart : null,
                dateEnd: dateEnd ? dateEnd : null,
                keyword: keyword ? keyword : null,
                typeCode: typeCode ? typeCode : null
            },
            pagination: paginationParams
        };
        const uri = `${SPE_VIEW_N_SPLIT}/v1/split/find`;
        return this.api.post(uri, body);
    }
    findSplitByUuid(uuid, uuidAccountPayment, typeCode) {
        const uri = `${SPE_VIEW_N_SPLIT}/v1/split/find/${uuid}/account-payment/${uuidAccountPayment}/type-code/${typeCode}`;
        return this.api.get(uri);
    }
    sumStatusValues(uuid, uuidAccountPayment, dateStart, dateEnd, status, keyword, typeCode, paginationParams) {
        const body = {
            filter: {
                splitUuid: uuid ? uuid : null,
                uuidAccountPayment: uuidAccountPayment ? uuidAccountPayment : null,
                status: status ? status : null,
                dateStart: dateStart ? dateStart : null,
                dateEnd: dateEnd ? dateEnd : null,
                keyword: keyword ? keyword : null,
                typeCode: typeCode ? typeCode : null
            },
            pagination: paginationParams
        };
        const uri = `${SPE_VIEW_N_SPLIT}/v1/split/sum-status`;
        return this.api.post(uri, body);
    }
    resumeSplitDataByTypeCode(uuid, uuidAccountPayment, dateStart, dateEnd, status, keyword, typeCode, paginationParams) {
        const body = {
            filter: {
                splitUuid: uuid ? uuid : null,
                uuidAccountPayment: uuidAccountPayment ? uuidAccountPayment : null,
                status: status ? status : null,
                dateStart: dateStart ? dateStart : null,
                dateEnd: dateEnd ? dateEnd : null,
                keyword: keyword ? keyword : null,
                typeCode: typeCode ? typeCode : null
            },
            pagination: paginationParams
        };
        const uri = `${SPE_VIEW_N_SPLIT}/v1/split/resume-values`;
        return this.api.post(uri, body);
    }
};
SpeViewNSplitProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeViewNSplitProxy);

let UiPxSplitModule = class UiPxSplitModule {
};
UiPxSplitModule = __decorate([
    NgModule({
        declarations: [],
        imports: [
            UiBsOauthModule
        ],
        providers: [
            ConfigService,
            SpeJSplitProxy,
            SpeViewNSplitProxy
        ]
    })
], UiPxSplitModule);

class SplitDto {
}

class SplitItemDto {
}

class StepsConclusionDto {
}

var StatusSplitEnum;
(function (StatusSplitEnum) {
    StatusSplitEnum["CREATED"] = "CREATED";
    StatusSplitEnum["AWAITING_APPROVAL"] = "AWAITING_APPROVAL";
    StatusSplitEnum["AVAILABLE_TO_LIBERATION"] = "AVAILABLE_TO_LIBERATION";
    StatusSplitEnum["IN_PROCESS"] = "IN_PROCESS";
    StatusSplitEnum["AVAILABLE"] = "AVAILABLE";
    StatusSplitEnum["CANCELED"] = "CANCELED";
    StatusSplitEnum["PROCESS_COMPLETED"] = "PROCESS_COMPLETED";
    StatusSplitEnum["PROCESS_COMPLETED_ERROR"] = "PROCESS_COMPLETED_ERROR";
    StatusSplitEnum["ERROR"] = "ERROR";
})(StatusSplitEnum || (StatusSplitEnum = {}));

var TypeCodeEnum;
(function (TypeCodeEnum) {
    TypeCodeEnum["BOALI"] = "BOALI";
    TypeCodeEnum["BOM_VALOR"] = "BOMVALOR";
})(TypeCodeEnum || (TypeCodeEnum = {}));

var StatusStepConclusionEnum;
(function (StatusStepConclusionEnum) {
    StatusStepConclusionEnum["EFFECTED"] = "EFFECTED";
    StatusStepConclusionEnum["PENDING"] = "PENDING";
})(StatusStepConclusionEnum || (StatusStepConclusionEnum = {}));

export { ConfigService, SpeJSplitProxy, SpeViewNSplitProxy, SplitDto, SplitItemDto, StatusSplitEnum, StatusStepConclusionEnum, StepsConclusionDto, TypeCodeEnum, UiPxSplitModule };
//# sourceMappingURL=wlp-ui-px-split.js.map
